var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceReceiptSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2D9CDB",
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.997 511.997",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M506.747,0.662c-3.191-1.323-6.869-0.614-9.318,1.843l-28.1,28.1l-28.1-28.1c-3.328-3.328-8.738-3.328-12.066,0 l-28.1,28.1l-28.1-28.1c-3.328-3.328-8.738-3.328-12.066,0l-28.1,28.1l-28.1-28.1c-3.328-3.328-8.738-3.328-12.066,0l-28.1,28.1 l-28.1-28.1c-2.449-2.44-6.118-3.183-9.301-1.852c-3.183,1.314-5.265,4.429-5.265,7.885c0,185.187-15.112,291.374-46.165,324.261 H8.537c-2.466,0-4.813,1.067-6.434,2.927c-1.621,1.869-2.355,4.335-2.022,6.775c11.477,82.866,33.604,167.805,110.855,169.495 h273.062c0.026,0,0.06,0,0.094,0c116.785-0.905,127.426-385.555,127.904-503.424C512.012,5.108,509.938,1.985,506.747,0.662z M322.447,494.93H111.123c-48.716-1.058-76.577-43.152-91.954-140.047c-0.41-2.594,1.604-5.018,4.232-5.018h155.773 c0.009-0.009,0.034-0.009,0.051,0h91.305c2.108,0,3.883,1.536,4.198,3.618c7.953,52.744,21.017,104.796,50.662,134.176 C328.105,490.357,326.27,494.93,322.447,494.93z M452.263,187.736H273.066c-4.71,0-8.533-3.823-8.533-8.533 s3.823-8.533,8.533-8.533h179.197c4.71,0,8.533,3.823,8.533,8.533S456.973,187.736,452.263,187.736z M452.263,145.07H273.066 c-4.71,0-8.533-3.823-8.533-8.533s3.823-8.533,8.533-8.533h179.197c4.71,0,8.533,3.823,8.533,8.533S456.973,145.07,452.263,145.07 z M452.263,102.404H273.066c-4.71,0-8.533-3.823-8.533-8.533s3.823-8.533,8.533-8.533h179.197c4.71,0,8.533,3.823,8.533,8.533 S456.973,102.404,452.263,102.404z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceReceiptSvgrepoCom);
export default __webpack_public_path__ + "static/media/invoice-receipt-svgrepo-com.9591f73939ab75cfcd6c7de31f8b242a.svg";
export { ForwardRef as ReactComponent };